document.addEventListener("DOMContentLoaded", () => {

//↓ javascript start


//accordion
const button = document.querySelector('.accordion__button');
if (button) {
  button.addEventListener('click', (e) => {
    const body = e.currentTarget.nextElementSibling;
    const menu = e.currentTarget.parentNode;
    menu.classList.toggle('open');

    if (menu.classList.contains('open')) {
      body.style.height = body.scrollHeight + 'px';
    } else {
      body.style.height = 0;
    }
  });
}


//mb-animation
(function () {
  const targets = document.querySelectorAll(
    '.mb-animation, .mb-animation-delay, .mb-animation-delay2'
  );
  if (!targets.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const el = entry.target;

      el.classList.add('mb-show');

      observer.unobserve(el);
    });
  }, { threshold: 0.2 });

  targets.forEach((el) => observer.observe(el));
})();


//mb-slide-up
(function () {
  const targets = document.querySelectorAll('.mb-slide-up, .mb-slide-up-delay, .mb-slide-up-delay2');
  if (!targets.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      
      el.classList.add('mb-show');

      observer.unobserve(el);
    });
  }, { threshold: 0.2 });

  targets.forEach((el) => observer.observe(el));
})();


//featured collection button add button--outline
const elements = document.querySelectorAll('.featured-collections-carousel__item .justify-self-center .button');
elements.forEach(element => {
  element.classList.add('button--outline');
});


//fade-slider
(function () {
  const sliders = document.querySelectorAll('.fade-slider');

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll('.slide');
    let index = 0;

    function showNext() {
      slides[index].classList.remove('active'); // 現在の画像をfade-out
      index = (index + 1) % slides.length;      // 次の画像へ
      slides[index].classList.add('active');    // fade-in
    }

    // 最初の画像を active にする（念のため）
    slides[0].classList.add('active');

    setInterval(showNext, 7500); // 7.5秒ごとに切り替え
  });
})();


//section slideshow
const options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.5   // ← 20% 入ったら発火
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const slide = entry.target.closest(".slideshow__slide");
      if (slide && !slide.classList.contains("mb-animated")) {
        slide.classList.add("mb-animated");

        // アニメーション関数を発火
        const seq = getSlideEnteringSequence_fn(slide);
        timeline14(seq);

      }
    }
  });
}, options);

document.querySelectorAll(".slideshow__slide-content").forEach(el => {
  observer.observe(el);
});



//↑ javascript end
});